module.exports = __webpack_public_path__ + "img/B4.e435a90a.png";